import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import { movetop } from "../../../fun";
import Cosmeticbody from "./Cosmeticbody";
import { Helmet } from "react-helmet-async";

function Cosmetic() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Cosmeticbody />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Cosmetic Treatment in Vijayanagar</title>
        <meta
          name="description"
          content="We give the best cosmetic treatment in Vijayanagar. Looking for this? Feel free to contact us today or call us now."
        />
        <meta
          name="keywords"
          content="Best cosmetic treatment in Whitefield, Best cosmetic treatment in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestcosmetictreatmentsinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestcosmetictreatmentsinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers advanced cosmetic treatments including skin rejuvenation, anti-aging procedures, laser therapies, body contouring, and other aesthetic services with experienced specialists and modern technology.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Skin rejuvenation treatments",
              "Anti-aging injectables and fillers",
              "Laser skin resurfacing",
              "Body contouring and fat reduction",
              "Scar revision & pigmentation treatments",
              "Non-surgical aesthetic procedures",
              "Cosmetic dermatology services",
            ],
            keywords: [
              "best cosmetic treatments in Immadihalli",
              "best cosmetic treatments in Whitefield",
              "best cosmetic treatments in Bangalore",
              "best cosmetic treatments in Kundalahalli",
              "best cosmetic treatments in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best cosmetic treatment in Vijayanagar rust us to bring out the best in
        your smile. Contact us for the best cosmetic treatment in Vijayanagar.
      </h2>

      <Servicebanner
        name="Cosmetic Treatments"
        banner={"../photo/cosbanner1.jpg"}
      />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Cosmetic;
